import { useLingui } from '@lingui/react/macro'
import { LucideIcon } from 'components/LucideIcon'
import { DropdownMenuContent } from 'designSystem/components/DropdownMenu'
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from 'designSystem/components/Sidebar'
import { useIsMobile } from 'designSystem/hooks/useMobile'
import { useSheetPortalHost } from 'designSystem/hooks/useSheetPortalHost'
import { StyledDropdownMenuTrigger } from 'features/navbar/NavbarDropdown'
import React from 'react'

import { ConfigSettingsBase } from './ConfigSettingsBase'
import {
  ConfigSettingsSidebarMenuItems,
  type WorkspaceSettingsNavigateHandler,
} from './ConfigSettingsSidebarMenuItems'
import { type ConfigSettingsProps } from './useConfigSettingsState'

export const ConfigSettingsSidebar: React.FC<
  ConfigSettingsProps & {
    onWorkspaceNavigate: WorkspaceSettingsNavigateHandler
  }
> = ({ orgID, siteID, onWorkspaceNavigate }) => {
  const { t } = useLingui()
  const isMobile = useIsMobile()
  const portalHost = useSheetPortalHost(isMobile)
  return (
    <ConfigSettingsBase
      orgID={orgID}
      renderTrigger={(state) => (
        <SidebarMenuItem>
          {portalHost.hostNode}
          <SidebarMenuButton asChild isActive={state.isOpen} variant='embedded'>
            <StyledDropdownMenuTrigger
              type='button'
              aria-label={t`Open config settings menu`}>
              <LucideIcon name='Settings' />
              <span>{t`Settings`}</span>
            </StyledDropdownMenuTrigger>
          </SidebarMenuButton>
        </SidebarMenuItem>
      )}
      renderContent={(state) => (
        <DropdownMenuContent
          side={isMobile ? 'top' : 'right'}
          sideOffset={12}
          align='end'
          width='md'
          container={portalHost.container}>
          <ConfigSettingsSidebarMenuItems
            orgID={orgID}
            siteID={siteID}
            state={state}
            onWorkspaceNavigate={onWorkspaceNavigate}
          />
        </DropdownMenuContent>
      )}
    />
  )
}
